"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderCard = exports.CellBox = exports.GridContainer = exports.IdLabel = exports.PageTypeTitle = void 0;
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const styledComponents_1 = require("./../styledComponents");
const format_1 = require("@/utils/format");
const Amount_1 = __importStar(require("./Amount"));
const AccountIdBox_1 = __importDefault(require("./AccountIdBox"));
const Card_1 = require("../dataCard/Card");
const SpecificHeader = ({ idType, pageTitle, id, balance, label, balanceLabel, additionalContent, }) => {
    return (react_1.default.createElement(material_1.Box, { sx: { gridColumn: 'span 12' } },
        react_1.default.createElement(exports.PageTypeTitle, null, pageTitle),
        react_1.default.createElement(exports.GridContainer, null,
            react_1.default.createElement(exports.CellBox, { col: 3 },
                react_1.default.createElement(exports.IdLabel, null, idType),
                react_1.default.createElement(AccountIdBox_1.default, { id: id, label: id, path: null, isNotLink: true, maxWidth: 400 }),
                label && react_1.default.createElement(styledComponents_1.Tag, null, label)),
            react_1.default.createElement(exports.CellBox, { col: 3 },
                react_1.default.createElement(Card_1.Card, { amountSize: Amount_1.AmountSize.Small, data: {
                        title: balanceLabel,
                        value: balance,
                    }, bg: "contrastBg" })),
            additionalContent?.map((e, i) => {
                if (e) {
                    return (react_1.default.createElement(exports.HeaderCard, { col: 2, sx: { height: '100%' } },
                        e.label && react_1.default.createElement(material_1.Box, null, e.label),
                        e.name && react_1.default.createElement(material_1.Box, null, e.name),
                        e.title && react_1.default.createElement(material_1.Box, null, e.title),
                        react_1.default.createElement(Amount_1.default, { amount: (0, format_1.formatAmount)(e.value), size: Amount_1.AmountSize.Small })));
                }
            }))));
};
exports.default = SpecificHeader;
exports.PageTypeTitle = (0, styled_components_1.default)(material_1.Box) `
  color: ${(props) => props.theme.colors.onBg};
  font-size: 1em;
`;
exports.IdLabel = (0, styled_components_1.default)(material_1.Box) `
  color: ${(props) => props.theme.colors.onBg};
  font-size: 0.82em;
`;
const Balance = (0, styled_components_1.default)(material_1.Box) `
  display: flex;
  align-items: center;
  font-size: 2em;
  color: ${(props) => props.theme.colors.onBg};
  font-weight: 300;
`;
exports.GridContainer = (0, styled_components_1.default)(material_1.Box) `
  display: grid;
  width: 100%;
  padding-top: ${(props) => props.theme.spacing.margin.lg};
  grid-template-columns: repeat(12, 1fr);
  gap: 20px;
`;
exports.CellBox = (0, styled_components_1.default)(material_1.Box) `
    grid-column: span ${(props) => props.col}};
    padding-right: 10px; 
    ${(props) => props.theme.media.lg} {
        grid-column: span 6;
    }
    ${(props) => props.theme.media.md} {
        grid-column: span 6;
    }
    ${(props) => props.theme.media.sm} {
        border-right: none;
        grid-column: span 12;
    }
    ${(props) => props.theme.media.xs} {
        grid-column: span 12;
        border-right: none;
    }
`;
exports.HeaderCard = (0, styled_components_1.default)(material_1.Box) `
    background-color: ${(props) => props.theme.colors.contrastBg};
    grid-column: span ${(props) => props.col}};
    padding: 20px;
    color: ${(props) => props.theme.colors.onContrastBg};
    border-radius: 20px;
    justify-content: flex-end;
    height: fit-content;
    ${(props) => props.theme.media.lg} {
        grid-column: span 6};
    }
    ${(props) => props.theme.media.md} {
        grid-column: span 6;
    }
    ${(props) => props.theme.media.sm} {
        grid-column: span 6;
    }
    ${(props) => props.theme.media.xs} {
        grid-column: span 6;
    }
`;
